import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { FormalityService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { StarActiveIcon, ViewIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
  onClose?: any;
  item?: any;
  history?: any;
}

class ModalView extends React.Component<Props> {
  state = {};

  view = (e: any) => {
    e.preventDefault();
    this.props.history.replace(
      '/admin/revision?revision_number=' + this.props.item?.revision?.number,
    );
  };

  render() {
    const { item } = this.props;

    return (
      <div id="modal-view-rating">
        {item != null && (
          <div className="container-rating">
            <div className="container-blue">
              <p>Calificación</p>
              <div className="container-stars">
                {item.rating >= 1 && <img src={StarActiveIcon} />}
                {item.rating >= 2 && <img src={StarActiveIcon} />}
                {item.rating >= 3 && <img src={StarActiveIcon} />}
                {item.rating >= 4 && <img src={StarActiveIcon} />}
                {item.rating >= 5 && <img src={StarActiveIcon} />}
              </div>
            </div>
            <p className="subtitle">
              {item.revision?.number} /{' '}
              {moment(item.created_at).format('DD-MM-YYYY')}
            </p>
            <p className="bold">Cliente</p>
            <p className="name">{item.user?.full_name}</p>
            <p className="name">
              <strong>C.I.</strong> {item.user?.full_document}
            </p>
            <p className="bold">Abogado</p>
            <p className="name">{item.lawyer?.full_name}</p>
            <p className="name">
              <strong>C.I.</strong> {item.lawyer?.full_document}
            </p>
            <p className="name">
              <strong>Inpre</strong> {item.lawyer?.lawyer_document}
            </p>
            <a href="#" onClick={this.view} className="container-type">
              <div>
                <p className="title">Tipo de tramite</p>
                <p>{item.name}</p>
              </div>
              <img src={ViewIcon} />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default ModalView;
